import "./FamilyMembersList.css";
import {
  GoabTable,
  GoabContainer,
  GoabFormItem,
  GoabCheckbox,
  GoabSpacer,
  GoabButton,
} from "@abgov/react-components";
import DisplayContent from "../../components/DynamicForm/Forms/DisplayContent"; 
import { domainKey, refCategories, getFullName } from "../../utils/globalUtility";

const FamilyMembersList = (input) => {
  const {
    familyMembers, 
    setSelectedFamilyMember, 
    setShowDeleteFamilyMember, 
    familyMemberWasChanged, 
    getResourceValue,
    getRefData,
    form,
    setFormData,
    isGenerator = false,
    applicationGeneration = 0,
    isGenerationTrackingEnabled,
    isEditable = true,
    handleAddFamilyMemberClick
  } = input;

  const relationshipRefData = getRefData({ category: refCategories.RELATIONSHIP, domainKey });

  // Check if family member can be edited/deleted based on generation (only if feature is enabled)
  const canModifyFamilyMember = (familyMember) => {
    if (!isGenerationTrackingEnabled) {
      return true; // If the feature is disabled, allow all modifications
    }
    const memberGeneration = familyMember?.generation ?? 0;
    // Can modify if member generation matches or is higher than app generation
    return memberGeneration >= applicationGeneration;
  };

  const handleChange = (form ,name, value) => {
    // Prevent updates to acceptLegalRepresentative when not editable
    if (name === 'acceptLegalRepresentative' && !isEditable) {
      return;
    }
    delete form.errors[name];
    form.setFieldValue(name, value);
    if (name === 'acceptLegalRepresentative' && value === true) {
      familyMemberWasChanged.current = false;
    }
    if (setFormData) {
      const formValue = {...form.values, [name]: value};
      setFormData(formValue);
    }
  };
  

  return (
    <>
      {familyMembers?.length > 0 && (
        <GoabContainer accent="thin" type="interactive">
          <h3>{getResourceValue({ key: "RESOURCES@familyMembers.title" })}</h3>
          <GoabSpacer vSpacing="l" />
          <GoabTable width="100%">
            <tbody>
              {familyMembers.map((fm) => {
                const canModify = canModifyFamilyMember(fm);
                return (
                  <tr key={fm.id}>
                    <td width="35%">
                      <strong>
                        {getFullName(fm.givenName, fm.middleName,fm.surname)}
                      </strong>
                    </td>
                    <td width="25%">  
                        {relationshipRefData?.find(ref => ref.code === fm.relationship)?.description ?? fm.relationship}
                    </td>
                    <td style={{float: 'right'}}>
                      <GoabButton
                        type="tertiary"
                        size="compact"
                        disabled={!canModify || !isEditable}
                        // leadingIcon="pencil"
                        onClick={() => setSelectedFamilyMember(fm)}
                      >
                        {getResourceValue({
                          key: "RESOURCES@global.button.manage",
                        })}
                      </GoabButton>
                    </td>
                    {/* <td>
                      <GoabButton
                        type="tertiary"
                        size="compact"
                        onClick={() => setShowDeleteFamilyMember(fm)}
                      >
                        {getResourceValue({
                          key: "RESOURCES@global.button.delete",
                        })}
                      </GoabButton>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </GoabTable>
        </GoabContainer>
      )}
      <GoabSpacer vSpacing="m" />
      <GoabButton
        type="secondary"
        leadingIcon="add"
        disabled={!isEditable}
        onClick={() => handleAddFamilyMemberClick({})}
      >
        {familyMembers?.length > 0
          ? getResourceValue({
              key: "RESOURCES@familyMembers.button.addAnotherFamilyMember",
            })
          : getResourceValue({
              key: "RESOURCES@familyMembers.button.addFamilyMember",
            })}
      </GoabButton>

      <GoabSpacer vSpacing="xl" />
          
      {familyMembers?.length > 0 && !isGenerator && (
        <>
          <GoabFormItem
            requirement="required"
            id="acceptLegalRepresentative"
            error={
              form.errors.acceptLegalRepresentative &&
              getResourceValue({
                key: form.errors.acceptLegalRepresentative,
              })
            }
          >
            <GoabCheckbox
              name="acceptLegalRepresentative"
              text={getResourceValue({
                key: "RESOURCES@familyMembers.acceptLegalRepresentative.label",
              })}
              checked={
                form.values.acceptLegalRepresentative &&
                !familyMemberWasChanged.current
              }
              error={form.errors.acceptLegalRepresentative}
              disabled={!isEditable}
              onChange={({name, checked, value}) => handleChange(form, name, checked)}
            ></GoabCheckbox>
          </GoabFormItem>
          <GoabSpacer vSpacing="s" />
        </>
      )}
      {!familyMembers?.length && !isGenerator && (
        <DisplayContent
          content={getResourceValue({
            key: "RESOURCES@familyMembers.nextStep.label",
          })}
        />
      )}
    </>
  );
};

export default FamilyMembersList;
